import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  faPen,
  faPlus,
  faSearch,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Contract } from 'src/app/core/models/Contract';
import { ContractService } from 'src/app/services/contract.service';
import { ContractTemplatesHandlerComponent } from '../contract-templates-handler/contract-templates-handler.component';

@Component({
  selector: 'app-entity-lookup',
  templateUrl: './entity-lookup.component.html',
  styleUrls: ['./entity-lookup.component.css'],
})
export class EntityLookupComponent implements OnInit {
  @Input() formInput: any;
  @Input() entryArray: any[] = [];
  @Input() searchType: string;
  @Input() title: string = 'Test';

  @Output() deleteElementEvent = new EventEmitter();
  @Output() addedEntityEvent = new EventEmitter();
  @Output() entitySelected = new EventEmitter();
  @Output() entityCreated = new EventEmitter();

  @ViewChild(ContractTemplatesHandlerComponent)
  entityForm: ContractTemplatesHandlerComponent;

  addTooltip: string = 'Añadir';
  dataForEdits: any;
  editIndex: number;
  contractId: number;
  contract: Contract;

  iconRemove = faTrash;
  iconEdit = faPen;
  iconPlus = faPlus;
  iconSearch = faSearch;

  constructor(
    private modalService: NgbModal,
    private contractService: ContractService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.contractId = params['id'];
    });
  }

  ngOnInit() {}

  openFormEdit(editData, ind) {
    this.editIndex = ind;
    this.dataForEdits = editData;

    this.entityForm.openForm(editData);
  }

  deleteItem(index) {
    if (this.searchType == 'building') {
      this.entryArray = null;
      this.deleteElementEvent.emit(this.entryArray);
    } else {
      this.entryArray.splice(index, 1);
      this.deleteElementEvent.emit(index);
    }
  }

  getData(index) {
    return this.entryArray[index];
  }

  searchModalRef: any;
  createModalRef: any;

  openSearch(searchForm) {
    this.searchModalRef = this.modalService.open(searchForm, { size: 'lg' });
  }

  openEntityForm() {
    console.log('EntityLookup - openEntityForm called with searchType:', this.searchType);
    if (this.searchType == 'building' && this.entryArray[0] == null) {
      this.editIndex = null;
      this.dataForEdits = null;
      this.createModalRef = this.entityForm.openForm(null);
    } else if (this.searchType != 'building') {
      this.editIndex = null;
      this.dataForEdits = null;
      this.createModalRef = this.entityForm.openForm(null);
    }
  }

  selectedSearchedElement(entity) {
    if (this.searchType == 'building') {
      this.entryArray = entity;
    } else {
      if (!this.entryArray.some(item => item.id === entity.id)) {
        this.entryArray.push(entity);
      }
    }

    // Solo cerrar el modal de búsqueda específico
    if (this.searchModalRef) {
      this.searchModalRef.close();
    }
    // Emitir el evento de selección
    this.entitySelected.emit(entity);
  }

  addEntityFromMemory(entity) {
    if (this.dataForEdits) {
      this.entryArray[this.editIndex] = entity;
    } else {
      if (!this.entryArray.some(item => item.id === entity.id)) {
        this.entryArray.push(entity);
      }
    }
    // Solo cerrar el modal de creación específico
    if (this.createModalRef) {
      this.createModalRef.close();
    }
    // Emitir el evento de creación
    this.entityCreated.emit(entity);
  }
}
